import styled from "styled-components";

import { grayScale, pink } from "@enkor/design/colors";

export const Button = styled.button<{
  $isReadyToSubmit?: boolean;
}>`
  width: 100%;
  height: 48px;
  padding: 12px;
  border: none;
  border-radius: 5px;

  background-color: ${({ $isReadyToSubmit }) =>
    $isReadyToSubmit ? pink.main : grayScale.main};

  color: ${({ $isReadyToSubmit }) =>
    $isReadyToSubmit ? grayScale.white : grayScale[500]};
  font-weight: 600;
  font-size: 16px;
  text-align: center;

  cursor: ${({ $isReadyToSubmit }) =>
    $isReadyToSubmit ? "pointer" : "not-allowed"};
  pointer-events: ${({ $isReadyToSubmit }) =>
    $isReadyToSubmit ? "unset" : "none"};

  transition: all 0.3s ease-in-out;

  &:hover {
    background-color: ${({ $isReadyToSubmit }) =>
      $isReadyToSubmit ? pink.main : pink[300]};

    color: ${grayScale.white};
  }
`;
